import { IAppState } from '../../../AppModulesWrapper';

import { selectIsPromotionPackageSelected } from './selectIsPromotionPackageSelected';
import { selectIsWithoutTopAndPremium } from './selectIsWithoutTopAndPremium';
import { selectIsServicesEnabled } from './selectIsServicesEnabled';

export const selectIsWithoutServices = (state: IAppState): boolean => {
  const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);
  const isWithoutTopAndPremium = selectIsWithoutTopAndPremium(state);
  const isServicesEnabled = selectIsServicesEnabled(state);

  return !isPromotionPackageSelected && (isWithoutTopAndPremium || !isServicesEnabled);
};
